module.exports = __webpack_public_path__ + "assets/img/enterIcon8.35879cd8.png";